<template>
  <div>
      <h3>Demandes de validations</h3>
      <search-bar></search-bar>
      
      <pagination v-if="paginationNeeded"
                  :current-page="currentPage"
                  :total-pages="totalPages" @click="getPageOnClick">
      </pagination>

      <table class="table table-condensed table-detailed table-borderless search-table"
        v-if="validationRequests && validationRequests.data && validationRequests.data.length > 0">
        <thead>
          <tr>
            <th colspan="2">Type</th>
            <th>
              <span>Création</span>
              <a v-if="'created_at' === sort" @click="updateSort('-created_at')" title="Trier par date de création descendante">
                <i class="fa fa-sort-asc"></i>
              </a>
              <a v-else @click="updateSort('created_at')" title="Trier par date de création ascendante">
                <i class="fa" :class="'-created_at' === sort ? 'fa-sort-desc' : 'fa-sort'"></i>
              </a>
            </th>
            <th>Statut</th>
            <th>
              <span>Demandeur</span>
              <a v-if="'customer.name' === sort" @click="updateSort('-customer.name')" title="Trier par raison sociale descendante">
                <i class="fa fa-sort-asc"></i>
              </a>
              <a v-else @click="updateSort('customer.name')" title="Trier par raison sociale ascendante">
                <i class="fa" :class="'-customer.name' === sort ? 'fa-sort-desc' : 'fa-sort'"></i>
              </a>
            </th>
            <th>Opérations</th>
          </tr>
        </thead>

        <tbody>
          <template v-for="(validationRequest, idx) in validationRequests.data">
            <demand 
              :key="'request-'+idx"
              :demand="validationRequest" 
              :index="idx" 
              :full_list="false"
              @show-details="showDetails($event)"
              :details="getDetails"
            >
            </demand>

            <demand-details 
              v-if="haveToShowDetails(idx)" 
              :key="'request-detail-'+idx"
              :demand="validationRequest" 
              :index="idx"
            ></demand-details>
          </template>
        </tbody>
      </table>

      <h5 v-else class="light">Aucun enregistrement correspondant</h5>

      <pagination v-if="paginationNeeded"
        :current-page="currentPage"
        :total-pages="totalPages"
        @click="getPageOnClick"
      ></pagination>
  </div>
</template>

<script>
  import CustomSelect from "components/Forms/Elements/Select"
  import SearchBar from "views/Demands/SearchBar"
  import Demand from 'views/Demands/Demand'
  import DemandDetails from "components/Demands/DemandDetails"
  import Pagination from "components/Pagination"

  import {mapActions, mapState} from 'vuex'

  export default {
      name:"Demands",

      data() {
        return {
          details: [],
          secondTime: false
        }
      },

      components: {
          SearchBar,
          DemandDetails,
          Demand,
          Pagination,
          CustomSelect
      },

      computed: {
        ...mapState('validationRequestsV2', ['validationRequests', 'filters', 'sort']),
        ...mapState(['agencies', 'user']),

        getDetails() {
          return this.details
        },

        paginationNeeded() {
          if (!this.validationRequests.hasOwnProperty('meta')) {
            return false
          }

          return this.validationRequests.meta.total > this.validationRequests.meta.per_page ? true : false
        },

        currentPage() {
          if (!this.validationRequests.hasOwnProperty('meta')) {
            return 1
          }

          return this.validationRequests.meta.current_page == 0 
            ? 1 
            : this.validationRequests.meta.current_page - 1
        },

        totalPages() {
          return this.validationRequests.hasOwnProperty('meta') ? this.validationRequests.meta.last_page : 1
        },

        main_agency() {
          return _.find(this.user.agencies, (agency) => !agency.virtual)
        }
      },

      methods: {
        ...mapActions('demands', ['validationRequestTreatmentForm']),
        ...mapActions('validationRequestsV2', ['getValidationRequests', 'updateSort']),

        showDetails(event) {
          if(event) {
            if (_.find(this.getDetails, (idx) => idx.idx == event.idx)) {
              _.remove(this.details, event)
            } else {
              this.details.push(event)
            }

            this.$forceUpdate()
          }
        },

        haveToShowDetails(index) {
          return _.find(this.getDetails, (idx) => idx.idx == index) != undefined ? true : false
        },

        get_form_of(demand_id) {
          return _.find(this.get_treatment_form, (tf) => tf.main_request.request.id === demand_id)
        },

        getPageOnClick(event) {
          if (event + 1 <= this.totalPages) {
            this.details = []
            
            let params = {
              filter: {
                is_parent: 1
              }, 
              with: "type,customer,validation_requestable,creating_user,treating_user",
              page: event + 1
            }

            this.getValidationRequests(params)
          }
        },
      },

      watch: {
        filters: {
            handler : function (newv, oldv) {
              // console.log('filters updated')
              
              if (this.filters.agency_id != {}) {
                let params = {
                  filter: {
                    is_parent: 1
                  }, 
                  with: "type,customer,validation_requestable,creating_user,treating_user",
                  page: this.currentPage
                }

                this.getValidationRequests(params)
              }
            },
            deep: true
        },
        sort: {
            handler : function (newv, oldv) {
              if (this.filters.agency_id != {}) {
                let params = {
                  filter: {
                    is_parent: 1
                  }, 
                  with: "type,customer,validation_requestable,creating_user,treating_user",
                  page: this.currentPage
                }

                this.getValidationRequests(params)
              }
            },
            deep: true
        }
      },
  }
</script>

<style scoped>
.w150 {
  width:150px;
}
.table thead tr th:first-child {
  width: 280px;
}
</style>



// WEBPACK FOOTER //
// client/views/Demands/Demands.vue